import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { Menu, X, Home, PaintBucket, Book, User, Mail } from "lucide-react";
import Logo from "../../LOGO.svg";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const menuItems = [
    { name: "Inicio", icon: <Home className="w-5 h-5" />, link: "#home" },
    {
      name: "Acrobacias",
      icon: <PaintBucket className="w-5 h-5" />,
      link: "#prints",
    },
    {
      name: "Galería",
      icon: <PaintBucket className="w-5 h-5" />,
      link: "#gallery",
    },
    { name: "Libro", icon: <Book className="w-5 h-5" />, link: "#stories" },
    { name: "Artista", icon: <User className="w-5 h-5" />, link: "#artist" },
    { name: "Contacto", icon: <Mail className="w-5 h-5" />, link: "#contact" },
  ];

  const navbarVariants = {
    hidden: { opacity: 0, y: -20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5,
        ease: "easeOut",
      },
    },
  };

  const mobileMenuVariants = {
    closed: {
      opacity: 0,
      x: "100%",
      transition: {
        duration: 0.5,
        ease: "easeInOut",
      },
    },
    open: {
      opacity: 1,
      x: 0,
      transition: {
        duration: 0.5,
        ease: "easeInOut",
      },
    },
  };

  return (
    <motion.nav
      initial="hidden"
      animate="visible"
      variants={navbarVariants}
      className={`fixed top-0 left-0 right-0 z-50 ${
        scrolled
          ? "bg-primary-dark bg-opacity-80 backdrop-blur-md border-b border-accent border-opacity-20"
          : "bg-transparent"
      } transition-all duration-300`}
    >
      <div className="container mx-auto px-4 py-3 flex justify-between items-center">
        <motion.div
          initial={{ opacity: 0, x: -20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.5, delay: 0.2 }}
          className="flex items-center"
        >
          <div>
            <img
              src={Logo}
              alt="Arte Olivieri Logo"
              className="h-8 w-auto ml-5 mr-5"
            />
          </div>
          <span className="text-accent-light text-2xl font-semibold tracking-tight">
            ARTE OLIVIERI
          </span>
        </motion.div>

        {/* Desktop Menu */}
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5, delay: 0.3 }}
          className="hidden md:flex items-center space-x-8"
        >
          {menuItems.map((item, index) => (
            <motion.a
              key={index}
              href={item.link}
              className="text-accent-light hover:text-accent text-sm font-medium transition-colors duration-300 flex items-center gap-2"
              whileHover={{ y: -2 }}
              transition={{ duration: 0.2 }}
            >
              {item.icon}
              <span>{item.name}</span>
            </motion.a>
          ))}
        </motion.div>

        {/* Mobile Menu Button */}
        <div className="md:hidden">
          <button
            onClick={toggleMenu}
            className="text-accent-light hover:text-accent focus:outline-none transition-colors duration-300"
          >
            {isOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      <motion.div
        initial="closed"
        animate={isOpen ? "open" : "closed"}
        variants={mobileMenuVariants}
        className="md:hidden fixed top-16 inset-x-0 h-screen bg-primary-dark bg-opacity-95 backdrop-blur-md z-40"
      >
        <div className="flex flex-col p-5 space-y-6">
          {menuItems.map((item, index) => (
            <motion.a
              key={index}
              href={item.link}
              onClick={() => setIsOpen(false)}
              className="text-accent-light hover:text-accent text-xl font-medium px-4 py-2 transition-colors duration-300 flex items-center gap-3 border-b border-accent border-opacity-20 pb-4"
              whileHover={{ x: 10 }}
              transition={{ duration: 0.2 }}
            >
              {item.icon}
              <span>{item.name}</span>
            </motion.a>
          ))}
        </div>
      </motion.div>
    </motion.nav>
  );
};

export default Navbar;
